module.exports = __webpack_public_path__ + "static/media/csk-tablet-738x57-80.d5467e8a.jpg";